let html = `<div class="ad-bot selector">
    <div class="ad-bot__content">
        <div class="ad-bot__body">
            <div class="ad-bot__left">
                <div class="smart">
                    <div class="smart__camera"></div>
                    <div class="smart__power"></div>
                    <div class="smart__body">
                        <div class="ad-bot__imgbox">
                            <img class="ad-bot__img" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ad-bot__right">
                <div class="ad-bot__title"></div>
                <div class="ad-bot__text"></div>
                <div class="ad-bot__more"></div>
            </div>
        </div>

        <div class="ad-bot__marker"></div>
    </div>
    <div class="ad-bot__info"></div>
</div>`

export default html